import * as React from 'react';

interface IFormLabelProps extends React.PropsWithChildren {
	htmlFor: string;
}

export const FormLabel: React.FC<IFormLabelProps> = ({ htmlFor, children }) => {
	return <label className="form__label" htmlFor={htmlFor}>{children}</label>;
};
